import { Icon, LoadingSpinner, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import ReactCountryFlag from 'react-country-flag'
import { Button } from 'src/design_system/molecules/button/Button'
import { useState } from 'src/hooks'
import { useDigitalGiftCardsAvailableCountries } from 'src/react_query'

type Props = {
  selectedValue: string
  onSelect: (selectedOption: string) => void
}

const CountrySelect: React.FC<Props> = props => {
  const { selectedValue, onSelect } = props

  const availableCountriesQuery = useDigitalGiftCardsAvailableCountries()

  const availableCountries = availableCountriesQuery.data ?? [selectedValue]

  // NOTE: Filtering available countries for now. Will change with
  // the upcoming designs
  const filteredAvailableCountries = availableCountries.filter(
    country => country === 'US' || country === 'CA',
  )

  const [isOpen, setIsOpen] = useState(false)

  return (
    <Button
      padding="2px 6px 2px 12px"
      borderRadius={isOpen ? '0.75rem 0.75rem 0 0' : '0.75rem'}
      fill="#FFF"
      boxShadow="0px 4px 8px 0px rgba(0, 0, 0, 0.08)"
      onClick={() => {
        setIsOpen(!isOpen)
      }}
      gap={'x_25'}
      wrapperInlineStyle={{ position: 'relative' }}
    >
      <ReactCountryFlag
        countryCode={selectedValue}
        svg={true}
        style={{
          height: '14px',
          borderRadius: '4px',
          marginRight: '4px',
        }}
      />
      <Text
        type="body"
        content={selectedValue}
        style={{
          fontSize: '0.75rem',
          fontWeight: 700,
          color: '#404040',
        }}
      />
      <div
        style={{
          display: 'flex',
          transform: isOpen ? 'rotate(90deg)' : 'rotate(-90deg)',
          transition: '0.2s',
        }}
      >
        <Icon name="leftChevron" size="xSmall" primaryColor="#6B7280" />
      </div>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            width: '100%',
            zIndex: 30,
            backgroundColor: '#fff',
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
            borderRadius: '0 0 12px 12px',
            maxHeight: '30vh',
            overflow: 'auto',
            scrollbarWidth: 'thin',
            borderTop: 'solid 2px #ccc',
          }}
        >
          {filteredAvailableCountries.map(countryCode => {
            return (
              <div
                onClick={() => {
                  onSelect(countryCode)
                }}
                style={{
                  paddingLeft: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                }}
              >
                <ReactCountryFlag
                  countryCode={countryCode}
                  svg={true}
                  style={{
                    height: '14px',
                    borderRadius: '4px',
                    marginRight: '4px',
                  }}
                />
                <Text
                  type="body"
                  content={countryCode}
                  style={{
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    color: '#404040',
                  }}
                />
              </div>
            )
          })}
          {availableCountriesQuery.isLoading && (
            <div style={{ margin: '1rem 0', overflow: 'hidden' }}>
              <LoadingSpinner size="small" />
            </div>
          )}
        </div>
      )}
    </Button>
  )
}

export default CountrySelect
